import { LanguageSupport } from "@codemirror/language"
import { StreamLanguage } from "@codemirror/language"

/**
 * Path of Exile Filter Language Definition for CodeMirror 6
 * 
 * This defines syntax highlighting for PoE item filter files using StreamLanguage.
 * Supports all standard filter syntax including conditions, actions, and values.
 */

// Simple stream-based language parser for PoE filter syntax
const poeFilterStreamLanguage = StreamLanguage.define({
  name: "poe-filter",

  startState() {
    return { firstToken: true }
  },
  
  token(stream, state) {
    if (stream.sol()) {
      state.firstToken = true
    }

    // Skip whitespace
    if (stream.eatSpace()) return null
    
    // Comments (lines starting with #)
    if (stream.match(/^#.*/)) {
      state.firstToken = false
      return "comment"
    }
    
    // Block types (Show, Hide, Continue)
    if (stream.match(/^(Show|Hide)(?=\s|$)/)) {
      state.firstToken = false
      return "keyword"
    }

    // Actions
    if (stream.match(/^(SetTextColor|SetBackgroundColor|SetBorderColor|SetFontSize|PlayAlertSound|PlayEffect|MinimapIcon|CustomAlertSound|DisableDropSound|EnableDropSound|Continue|PlayAlertSoundPositional|CustomAlertSoundOptional|DisableDropSoundIfAlertSound|EnableDropSoundIfAlertSound)(?=\s|$)/)) {
      state.firstToken = false
      return "function"
    }

    // Conditions are capitalized identifiers in the first position of a line.
    // The linter performs the stricter realm-aware keyword validation.
    if (state.firstToken && stream.match(/^[A-Z][A-Za-z0-9]*(?=\s|$)/)) {
      state.firstToken = false
      return "propertyName"
    }
    
    // Operators
    if (stream.match(/^(==|!=|<=|>=|[=<>!])/)) {
      return "operator"
    }
    
    // Numbers
    if (stream.match(/^\d+/)) {
      return "number"
    }
    
    // Quoted strings
    if (stream.match(/^"[^"]*"/)) {
      return "string"
    }
    
    // Boolean values
    if (stream.match(/^(True|False)(?=\s|$)/)) {
      return "atom"
    }
    
    // Rarity values
    if (stream.match(/^(Normal|Magic|Rare|Unique)(?=\s|$)/)) {
      return "variableName"
    }
    
    // Default: consume one character
    state.firstToken = false
    stream.next()
    return null
  },
  
  languageData: {
    commentTokens: { line: "#" }
  }
})

// Create the language support
export function poeFilter() {
  return new LanguageSupport(poeFilterStreamLanguage)
}

// Export language data for autocomplete
export const POE_FILTER_DATA = {
  keywords: ['Show', 'Hide'],
  conditions: [
    'BaseType', 'Class', 'ItemLevel', 'DropLevel', 'Quality', 'Rarity',
    'Sockets', 'LinkedSockets', 'SocketGroup', 'Height', 'Width',
    'HasExplicitMod', 'HasEnchantment', 'EnchantmentPassiveNode',
    'Corrupted', 'Mirrored', 'ElderItem', 'ShaperItem', 'FracturedItem',
    'SynthesisedItem', 'AnyEnchantment', 'HasInfluence', 'InfluenceType',
    'ElderMap', 'BlightedMap', 'UberBlightedMap', 'MapTier', 'AreaLevel',
    'GemLevel', 'StackSize', 'Replica', 'AlternateQuality', 'Identified'
  ],
  actions: [
    'SetTextColor', 'SetBackgroundColor', 'SetBorderColor', 'SetFontSize',
    'PlayAlertSound', 'PlayEffect', 'MinimapIcon', 'CustomAlertSound',
    'DisableDropSound', 'EnableDropSound', 'Continue','PlayAlertSoundPositional', 
    'CustomAlertSoundOptional', 'DisableDropSoundIfAlertSound', 'EnableDropSoundIfAlertSound'
  ],
  operators: ['=', '==', '!=', '!', '<', '>', '<=', '>='],
  values: {
    rarity: ['Normal', 'Magic', 'Rare', 'Unique'],
    boolean: ['True', 'False'],
    influence: ['None', 'Shaper', 'Elder', 'Crusader', 'Hunter', 'Redeemer', 'Warlord']
  }
}
